import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { radioPrefixCls } from "@/base/components/radio/Radio.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Radio">> = ({
  colorDot,
  colorBgDot,
  colorHoverBgContainer,
  colorText,
}: any) => ({
  [`.${radioPrefixCls}-option-type-button`]: {
    display: "flex !important",

    [`.${radioPrefixCls}-button-wrapper`]: {
      flex: "1",
      "text-align": "center !important",
    },
  },
  [`.${THEME_PREFIX}`]: {
    [`&.${radioPrefixCls}-wrapper:not(.${radioPrefixCls}-wrapper-disabled)`]: {
      [`.${radioPrefixCls}.${radioPrefixCls}-checked .${radioPrefixCls}-inner`]:
        {
          backgroundColor: colorBgDot,
          [`&::after`]: {
            backgroundColor: colorDot,
          },
        },
    },
    [`&.${radioPrefixCls}-wrapper:hover:not(.${radioPrefixCls}-wrapper-disabled)`]:
      {
        [`.${radioPrefixCls}:not(.${radioPrefixCls}-checked) .${radioPrefixCls}-inner`]:
          {
            backgroundColor: colorHoverBgContainer,
          },
      },
    [`&.${radioPrefixCls}-button-wrapper`]: {
      [`&:not(.${radioPrefixCls}-button-wrapper-disabled):not(.${radioPrefixCls}-button-wrapper-checked):hover`]:
        {
          backgroundColor: colorHoverBgContainer,
          color: colorText,
        },
      [`&::before`]: {
        content: "none",
      },
    },
  },
});

export const useRadioStyle = genComponentStyleHook(
  ["Radio", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
